jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.slider').length ) {
        let $ = jQuery;
        $("section.slider").each(function () {
            $slides = $(this).find(".slides");
            $navItems = $(this).find('.slider-nav-item');
            $slide = $(this).find('.slide');

            $slides.slick({
                arrows: false,
                autoplay: true,
                autoplaySpeed: 5000, 
                dots: false,
                fade: true,
                rows: 0,
                scrollable: false,
                draggable: false,
                swipe: false,
                swipeToSlide: false
            });

            $slides.on('afterChange', function (event, slick, currentSlide) {
                let target = $(this).data('slides_for');
                let $nav = $(this).parents('section.slider').find(".slider-nav[data-nav_for='" + target + "']");
                $nav.find('.active').removeClass('active');
                $nav.find(".slider-nav-item[data-slide='" + (currentSlide + 1) + "']").addClass('active')
                    .find('.indicator').addClass('active');
            });

            $navItems.on("click", function (e) {
                let target = $(this).parent('.slider-nav').data('nav_for');
                console.log(target);
                $(this).parents(".slider-nav[data-nav_for='"+target+"']").find('.active').removeClass('active');
                $(this).children('.indicator').addClass('active');
                $(this).addClass('active');
                e.preventDefault();
                var slideno = $(this).data('slide');
                $(this).parents().find(".slides[data-slides_for='"+target+"']").slick('slickGoTo', slideno - 1);
            });

                $(".slide-swapper .slide-content-link").on('mousedown touchdown mouseover', function () {
                   $(this).siblings().removeClass('active');
                   $(this).addClass('active');
                   let $title = $(this).data('title'),
                   $subtitle = $(this).data('subtitle'),
                   $description = $(this).data('description'),
                   $link_text = $(this).data('link_text'),
                   $link_url = $(this).data('link_url'),
                   $background = $(this).data('background');

                   $slide_background = $(this).parents('.slide');
                   $slide_background.css("background-image", "url('"+$background+"')");
                   $content_holder = $(this).parents('.slide-swapper').siblings('.content-holder');
                   $content_holder.css('opacity', '0');

                   setTimeout(function () {
                       $content_holder.find('.title').text($title);
                       $content_holder.find('.subtitle').text($subtitle);
                       $content_holder.find('.description').text($description);
                       $content_holder.find('.content-link span').text($link_text);
                       $content_holder.find('.content-link').attr("href", $link_url);
                       $content_holder.css('opacity', '1');
                   }, 450)

                });

                if($(window).width() <= 992) {
                    $(".slide-swapper .slide-content-link").on('mousedown touchdown', function () {
                        window.location.replace($(this).data('link_url'));
                    });
                }
        })

    }
});